import React, { useState } from "react";
import styles from "./MWrap.module.css";

interface MWrapProps {
  text: string;
  maxChars: number;
  className?: string;
}

const MWrap: React.FC<MWrapProps> = ({ text, maxChars, className = "" }) => {
  const [open, setOpen] = useState(false);
  const isTruncated = text.length > maxChars;
  const mainText = isTruncated ? text.slice(0, maxChars) : text;

  return (
    <span
      className={`${styles.mWrap} ${className}`}
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {mainText}
      {isTruncated && (
        <>
          <span className={styles.ellipsis}>…</span>
          {/* <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <span
                className={styles.iconWrap}
                onClick={e => {
                  e.stopPropagation();
                  setOpen((v) => !v);
                }}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                tabIndex={0}
                role="button"
                aria-label="Show full text"
              >
                <IconInfoCircle size={16} />
              </span>
            </PopoverTrigger>
            <PopoverContent side="top" sideOffset={8} align="center" className={styles.bubblePopover}>
              <span className={styles.fullText}>{text}</span>
              <span className={styles.bubbleArrow} />
            </PopoverContent>
          </Popover> */}
        </>
      )}
    </span>
  );
};

export default MWrap;
